import { DEFAULT_SOUND, type SoundConfig } from '@game-platform/pack-animation';
import { Checkbox } from '../../components/ui/Checkbox';
import { RangeInput } from '../../components/ui/RangeInput';

interface Props {
  /** Absent means the default: on, at 80%. */
  sound: SoundConfig | undefined;
  onChange: (sound: Partial<SoundConfig>) => void;
}

/** The ceremony's sound for every player of this template: on or off, and how loud. */
export function SoundPanel({ sound, onChange }: Props) {
  const current = sound ?? DEFAULT_SOUND;
  return (
    <section>
      <h2 className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-[var(--co-muted)]">
        Sound
      </h2>
      <Checkbox
        aria-label="Sound"
        label="Play sounds during the opening"
        checked={current.enabled}
        onChange={(enabled) => onChange({ enabled })}
      />
      <div className="mt-3">
        <div className="mb-1 text-[12px] text-[var(--co-text)]">Volume</div>
        <RangeInput
          aria-label="Volume"
          value={Math.round(current.volume * 100)}
          min={0}
          max={100}
          step={5}
          disabled={!current.enabled}
          onChange={(value) => onChange({ volume: value / 100 })}
          format={(value) => `${value}%`}
        />
      </div>
    </section>
  );
}
